<ion-grid>
	<form [formGroup]="editForm" (ngSubmit)="onSubmit(editForm)">
		<ion-row class="background-Blues-Light_Blue_3 pt-24">
			<ion-col class="top-box my-10 mx-16">
				<div class="flex">
					<ion-icon
						name="close-outline"
						class="close-icon"
						(click)="close()"
					></ion-icon>
					<span class="Body_M color-Blacks-Default_Black"
						>Edit Courses information</span
					>
				</div>
				<ion-button class="Small-button-Active_primary_with_icon" type="submit">
					Done
					<ion-spinner *ngIf="isLoading"></ion-spinner>
					<ion-icon name="checkmark-outline" *ngIf="!isLoading"></ion-icon>
				</ion-button>
			</ion-col>
		</ion-row>
		<ion-row class="p-16 row-gap-16 Body_M">
			<ion-col size="12">
				<ion-grid>
					<ion-row>
						<ion-col size="12" class="pb-8"> Courses Name </ion-col>
					</ion-row>
					<ion-row class="Elevation-1_Flat">
						<ion-col size="12" class="bb">
							<ion-input
								class="input"
								placeholder="Course name"
								formControlName="name"
							></ion-input>

							<ng-container
								*ngFor="let validation of editFormErrorMessages.name"
							>
								<div
									class="errorMessageClass flex items-center mb-12 ml-12"
									*ngIf="
										editForm.get('name')?.hasError(validation.type) &&
										(editForm.get('name')?.dirty ||
											editForm.get('name')?.touched)
									"
								>
									<ion-icon
										name="close-circle"
										class="text-rose-600"
									></ion-icon>
									<span class="text-rose-600 ml-8 mt-2">{{
										validation.message
									}}</span>
								</div>
							</ng-container>
						</ion-col>
					</ion-row>
				</ion-grid>
			</ion-col>
			<ion-col size="12">
				<ion-grid>
					<ion-row>
						<ion-col size="12" class="pb-8"> Courses Description</ion-col>
					</ion-row>
					<ion-row class="Elevation-1_Flat">
						<ion-col size="12" class="bb">
							<ion-input
								class="input"
								placeholder="Enter description "
								formControlName="description"
							></ion-input>
							<ng-container
								*ngFor="let validation of editFormErrorMessages.description"
							>
								<div
									class="errorMessageClass flex items-center mb-12 ml-12"
									*ngIf="
										editForm.get('description')?.hasError(validation.type) &&
										(editForm.get('description')?.dirty ||
											editForm.get('description')?.touched)
									"
								>
									<ion-icon
										name="close-circle"
										class="text-rose-600"
									></ion-icon>
									<span class="text-rose-600 ml-8 mt-2">{{
										validation.message
									}}</span>
								</div>
							</ng-container>
						</ion-col>
					</ion-row>
				</ion-grid>
			</ion-col>

			<ion-col size="12">
				<ion-grid>
					<ion-row>
						<ion-col size="12" class="pb-8"> Price </ion-col>
					</ion-row>
					<ion-row class="Elevation-1_Flat">
						<ion-col size="12" class="bb">
							<ion-input
								class="input"
								placeholder="Enter course price "
								formControlName="price"
							></ion-input>
							<ng-container
								*ngFor="let validation of editFormErrorMessages.price"
							>
								<div
									class="errorMessageClass flex items-center mb-12 ml-12"
									*ngIf="
										editForm.get('price')?.hasError(validation.type) &&
										(editForm.get('price')?.dirty ||
											editForm.get('price')?.touched)
									"
								>
									<ion-icon
										name="close-circle"
										class="text-rose-600"
									></ion-icon>
									<span class="text-rose-600 ml-8 mt-2">{{
										validation.message
									}}</span>
								</div>
							</ng-container>
						</ion-col>
					</ion-row>
				</ion-grid>
			</ion-col>

			<ion-col size="6">
				<ion-grid>
					<ion-row>
						<ion-col size="12" class="pb-8"> Visible</ion-col>
					</ion-row>
					<ion-row class="Elevation-1_Flat">
						<ion-col size="12" class="bb">
							<ion-toggle formControlName="visible"></ion-toggle>
						</ion-col>
					</ion-row>
				</ion-grid>
			</ion-col>
		</ion-row>
	</form>
</ion-grid>
